{
    "name": "@duckdb/duckdb-wasm-shell",
    "version": "1.33.1-dev45.0",
    "description": "",
    "author": "Andre Kohn <kohn.a@outlook.com>",
    "license": "MIT",
    "repository": {
        "type": "git",
        "url": "https://github.com/duckdb/duckdb-wasm.git"
    },
    "keywords": [
        "sql",
        "duckdb",
        "relational",
        "database",
        "data",
        "query",
        "wasm",
        "analytics",
        "olap",
        "arrow",
        "parquet",
        "json",
        "csv"
    ],
    "dependencies": {
        "@duckdb/duckdb-wasm": "^1.33.1-dev45.0",
        "qs": "^6.14.1",
        "xterm": "^5.3.0",
        "xterm-addon-fit": "^0.8.0",
        "xterm-addon-web-links": "^0.9.0",
        "xterm-addon-webgl": "^0.16.0"
    },
    "devDependencies": {
        "esbuild": "^0.20.2",
        "eslint": "^8.57.0",
        "eslint-plugin-jasmine": "^4.1.3",
        "eslint-plugin-react": "^7.37.5",
        "jasmine": "^5.13.0",
        "jasmine-core": "^5.1.2",
        "jasmine-spec-reporter": "^7.0.0",
        "make-dir": "^4.0.0",
        "prettier": "^3.2.5",
        "rimraf": "^5.0.5",
        "wasm-pack": "^0.13.1"
    },
    "scripts": {
        "install:wasmpack": "node ../../node_modules/wasm-pack/install.js",
        "build:debug": "node bundle.mjs debug && tsc --emitDeclarationOnly",
        "build:release": "node bundle.mjs release && tsc --emitDeclarationOnly",
        "lint": "eslint src"
    },
    "files": [
        "dist",
        "!dist/types/test"
    ],
    "main": "dist/shell.cjs",
    "module": "dist/shell.mjs",
    "types": "dist/shell.d.ts",
    "jsdelivr": "dist/shell.cjs",
    "unpkg": "dist/shell.mjs",
    "sideEffects": false,
    "exports": {
        "./dist/shell_bg.wasm": "./dist/shell_bg.wasm",
        "./dist/shell.js": "./dist/shell.js",
        "./dist/shell.cjs": "./dist/shell.cjs",
        "./dist/shell.mjs": "./dist/shell.mjs",
        "./dist/shell": "./dist/shell.mjs",
        ".": {
            "types": "./dist/shell.d.ts",
            "import": "./dist/shell.mjs",
            "require": "./dist/shell.cjs"
        }
    }
}
